import { gql } from "apollo-boost";

export const CREATE_LISTING_NOTE = gql`
  mutation($listing_id: ID!, $listing_type: PropertyType!, $note: String!) {
    create_listing_note(
      input: {
        listing_id: $listing_id
        listing_type: $listing_type
        note: $note
      }
    ) {
      ... on ListingNoteErrors {
        errors {
          message
          type
        }
      }
      ... on ListingNoteResult {
        successful
      }
    }
  }
`;

export const UPDATE_LISTING_NOTE = gql`
  mutation($listing_id: ID!, $listing_type: PropertyType!, $note: String!) {
    update_listing_note(
      input: {
        listing_id: $listing_id
        listing_type: $listing_type
        note: $note
      }
    ) {
      ... on ListingNoteErrors {
        errors {
          message
          type
        }
      }
      ... on ListingNoteResult {
        successful
      }
    }
  }
`;
